import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflowWrap: 'anywhere'
  },
  details: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr)',
    columnGap: theme.spacing(1.5),
    rowGap: theme.spacing(0.75),
    marginBottom: theme.spacing(3)
  },
  detailLabel: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap'
  },
  detailValue: {
    color: theme.palette.text.primary
  },
  // The operational surface - tinted and bordered so choosing a size reads as
  // the action, distinct from the read-only details above it.
  panel: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2)
  },
  label: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.5)
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.75),
    '&:not(:last-of-type)': {
      marginBottom: theme.spacing(1.5)
    }
  },
  optionSelected: {
    border: `1.5px solid ${theme.palette.primary.main}`
  },
  // A tier the user cannot pick has to look unavailable, not just inert - the
  // tooltip on the row explains which of the two reasons applies.
  optionDisabled: {
    opacity: 0.5
  },
  // The label carries the row's padding so it spans the whole card, making the
  // card and the control the same target.
  radio: {
    margin: 0,
    width: '100%',
    padding: theme.spacing(1.5)
  },
  note: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1.5)
  },
  emptyState: {
    color: theme.palette.text.secondary
  },
  warning: {
    marginTop: theme.spacing(2)
  }
}));

export default createClasses;
